<template>
  <div>
    <a-row class="depart-detail" type="flex" justify="space-between">
      <a-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
        <img
          v-if="departDetail.departCover"
          :src="departDetail.departCover_url"
          alt=""
        />
        <img v-else src="@/assets/icon/school.png" alt="" />
      </a-col>
      <a-col :xs="24" :sm="24" :md="16" :lg="16" :xl="16" class="depart-desc">
        <a
          class="depart-name"
          :href="departDetail.departLink ? departDetail.departLink : '#'"
          target="_blank"
          >{{ departDetail.departName }}</a
        >
        <h2>简介:</h2>
        <div v-html="departDetail.departDesc"></div>
        <h2 v-if="departDetail.address">地址:</h2>
        <span v-if="departDetail.address">{{ departDetail.address }}</span>
      </a-col>
    </a-row>
    <div class="select">
      <!-- <a
        href="javascript:void(0)"
        @click="getDepartWork('file')"
        :class="tab == 'file' ? 'selected' : ''"
        >积木构建项目</a
      > -->
      <a
        href="javascript:void(0)"
        @click="getDepartWork('scratchjr')"
        :class="tab == 'scratchjr' ? 'selected' : ''"
        >Scratch jr</a
      >
      <a
        href="javascript:void(0)"
        @click="getDepartWork('scratch')"
        :class="tab == 'scratch' ? 'selected' : ''"
        >Scratch</a
      >
      <a
          href="javascript:void(0)"
          @click="getDepartWork('blockly')"
          :class="tab=='blockly' ? 'selected' : ''"
          >Blockly</a
        >
      <a
        href="javascript:void(0)"
        @click="getDepartWork('python')"
        :class="tab == 'python' ? 'selected' : ''"
        >Python</a
      >
      <a href="javascript:void(0)"
          @click="getDepartWork('clang')"
          :class="tab=='clang' ? 'selected' : ''"
          >C++</a>
      <a
        href="javascript:void(0)"
        @click="getDepartNews('news')"
        :class="tab == 'news' ? 'selected' : ''"
        >资讯</a
      >
      <a
        href="javascript:void(0)"
        @click="getDepartStudent()"
        :class="tab == 'student' ? 'selected' : 'colorWihte'"
        >成员</a
      >
    </div>
    <a-card :bordered="false" v-if="tab == 'student'">
      <a-row type="flex" :gutter="[24, 24]">
        <a-col v-for="(item, index) in studentlist" :key="index" :xs="24" :sm="12" :md="8" :lg="6" :xl="6">
          <a-card class="user-card" @click="toUserInfo(item.id)">
            <a-row>
              <a-col :span="6">
                <a-avatar
                  shape="square"
                  class="avatar"
                  :size="40"
                  :src="item.avatar?item.avatar_url:'/img/avatar.png'"
                />
              </a-col>
              <a-col :span="18">
                <h2 class="name">
                  {{ item.nickname || item.realname || item.username }}
                </h2>
                <p>签名：<j-ellipsis :value="item.sign" :length="20" /></p>
              </a-col>
            </a-row>
          </a-card>
        </a-col>
      </a-row>
    </a-card>
     <a-card :bordered="false" v-else-if="tab == 'news'">
      <a-list :dataSource="newsList">
      <a-list
        item-layout="vertical"
        size="large"
        :data-source="newsList"
      >
        <div slot="footer">共{{ ipagination.total }}篇</div>
        <a-list-item slot="renderItem" key="item.title" slot-scope="item">
          <a-list-item-meta :description="item.description">
            <a slot="title" @click="toCmsDetail(item)"
              ><h3 class="title">{{ item.cmsTitile }}</h3></a
            >
          </a-list-item-meta>
          <p v-if="item.cmsDesc">
            {{ item.cmsDesc }}
          </p>
          <div class="cms-info">
            <a-icon type="clock-circle" />
            <span class="gap"> {{ item.createTime }}</span>
          </div>
        </a-list-item>
      </a-list>
    </a-list>
     </a-card>
    <a-card :bordered="false" v-else>
      <a-row type="flex" :gutter="[24, 24]">
        <a-col v-show="queryParam.langType==undefined||queryParam.langType=='scratch'" :xs="24" :sm="24" :md="24" :lg="15" :xl="16" class="catalog">
          <div
            :class="['tag-wrap', queryParam.workTag == '' ? 'selected' : '']"
            @click="queryParam.workTag='';pageChange(1,10)"
          >
            所有
          </div>
          <div
            :class="['tag-wrap', queryParam.workTag == tag ? 'selected' : '']"
            v-for="(tag, index) in tags"
            :key="index"
            @click="queryParam.workTag=tag;pageChange(1,10)"
          >
            {{ tag }}
          </div>
        </a-col>
        <a-col :xs="24" :sm="24" :md="24" :lg="9" :xl="8">
          <a-input-search
            placeholder="搜索"
            style="width: 200px"
            @search="onSearch"
          />
          <a-divider type="vertical"></a-divider>
          <a-radio-group v-model="queryParam.orderBy">
            <a-radio-button value="view"> 最热 </a-radio-button>
            <a-radio-button value="time"> 最新 </a-radio-button>
          </a-radio-group>
        </a-col>
      </a-row>
      <a-row type="flex" :gutter="[24, 24]">
        <a-col v-for="(item, index) in workList" :key="index" :xs="24" :sm="12" :md="8" :lg="6" :xl="6">
          <a-card class="work-card">
            <div class="work-cover">
              <a @click="toWorkDetail(item)" target="_blank" class="img-zoom">
                <img v-if="item.workCover" :src="item.workCover_url" />
                <img v-else :src="getCodeIcon(item.codeType)" />
              </a>
            </div>
            <a-row class="work-author">
              <a-col :span="6">
                <a-avatar
                  shape="square"
                  class="avatar"
                  :size="40"
                  :src="item.avatar?item.avatar_url:'/img/avatar.png'"
                   @click="toUserInfo(item.userId)" style="cursor:pointer"
                />
              </a-col>
              <a-col :span="18">
                <span  @click="toUserInfo(item.userId)" style="cursor:pointer">{{ item.realname || item.username }}</span>
              </a-col>
            </a-row>
            <a-divider></a-divider>
            <div class="work-op">
              <a @click="toWorkDetail(item)">{{ item.workName }}</a>
              <a-row type="flex" justify="end">
                <a-col :span="6">
                  <a-icon type="eye" /> {{ item.viewNum }}
                </a-col>
                <a-col :span="6">
                  <a-icon type="like" /> {{ item.starNum }}
                </a-col>
              </a-row>
            </div>
          </a-card>
        </a-col>
      </a-row>
    </a-card>
    <a-pagination
      @change="pageChange"
      :current="ipagination.current"
      :pageSize="ipagination.pageSize"
      :pageSizeOptions="ipagination.pageSizeOptions"
      :showTotal="ipagination.showTotal"
      :total="ipagination.total"
      showQuickJumper
    />
  </div>
</template>

<script>
import "@/assets/less/animation.css";
import { getAction } from "@/api/manage";
import JEllipsis from "@/components/jeecg/JEllipsis";
import {getEditorUrl, getPlayerUrl, getCodeIcon} from '@/utils/codeTypeUtil.js'

export default {
  name: "SchoolDetail",
  components: {
    JEllipsis,
  },
  data() {
    return {
      departId: "",
      departDetail: {},
      workList: [],
      studentlist: [],
      newsList: [],
      tab: "scratch", //student news ...
      ipagination: {
        current: 1,
        pageSize: 10,
        showTotal: (total, range) => {
          return range[0] + "-" + range[1] + " 共" + total + "条";
        },
        showQuickJumper: true,
        total: 0,
      },
      queryParam: {},
      tags: ["游戏", "动画", "音乐", "模拟", "搞笑", "故事", "赛事"],
    };
  },
  created() {
    this.departId = this.$route.query.id;
    this.getDepartDetail();
    this.pageChange(1, 12);
  },
  methods: {
    getEditorUrl,
    getPlayerUrl,
    getCodeIcon,
    getDepartDetail() {
      getAction("/sys/sysDepart/departDetail", {
        departId: this.departId,
      }).then((res) => {
        this.departDetail = res.result;
      });
    },
    getDepartStudent() {
      this.tab = "student";
      this.queryParam.depId = this.departId;
      getAction("/sys/user/schoolUserList", this.queryParam).then((res) => {
        if (res.success) {
          this.ipagination.total = res.result.total;
          this.studentlist = res.result.records;
        }
      });
    },
    getDepartWork(type) {
      this.tab = type;
      this.queryParam.langType=type
      this.queryParam.depId = this.departId;
      this.queryParam.orderBy = "time";
      getAction("/teaching/teachingWork/leaderboard", this.queryParam).then(
        (res) => {
          if (res.success) {
            this.ipagination.total = res.result.total;
            this.workList = res.result.records;
          }
        }
      );
    },
    getDepartNews(){
      this.tab = "news";
      this.queryParam.depId = this.departId;
      getAction("/teaching/teachingCms/getCmsList", this.queryParam).then((res) => {
        if (res.success) {
          this.ipagination.total = res.result.total;
          this.newsList = res.result.records;
        }
      });
    },
    pageChange(page, pageSize) {
      this.ipagination.current = page;
      this.queryParam.pageNo = this.ipagination.current;
      console.log(this.queryParam);
      if (this.tab == "student") {
        this.queryParam.pageSize = 32;
        this.ipagination.pageSize = 32
        this.getDepartStudent();
      }else if(this.tab == "news"){
        this.queryParam.pageSize = 10;
        this.ipagination.pageSize = 10;
        this.getDepartNews()
      } else {
        this.queryParam.pageSize = 24;
        this.ipagination.pageSize = 32
        this.getDepartWork(this.tab);
      }
    },
    onSearch(v) {
      console.log(v);
    },
    toWorkDetail(info) {
      if (info.codeType == 0) {
        this.$router.push("/work/mdView?workId=" + info.id);
      } else {
        this.$router.push("/work/detail?workId=" + info.id);
      }
    },
    toCmsDetail(item) {
      let route = this.$router.resolve({
        path: "/cms/detail",
        query: {
          id: item.id,
        },
      });
      window.open(route.href, '_blank');
    },
    toUserInfo(userId){
      this.$router.push("/friend/detail?id=" + userId)
    },
  },
};
</script>

<style lang="less" scoped>
.depart-detail {
  width: 100%;
  min-height: 280px;
  padding: 0;
  overflow: hidden;
  border-radius: 10px;
  box-shadow: 0px 3px 6px #00000039;
  img {
    height: 280px;
    max-width: 100%;
    width: auto;
    display: block;
    margin: 0 auto;
  }
  .depart-name {
    display: block;
    margin: 20px 0;
    font: normal normal normal 25px/31px Source Han Sans CN;
  }
  .depart-desc {
    padding: 20px;
  }
}

.catalog {
  color: #027db4;
  .tag-wrap {
    cursor: pointer;
    display: inline;
    border-radius: 50px;
    background: #f2f2f2;
    margin: 0 10px;
    padding: 5px 10px;
    font-size: 14px;
    line-height: 40px;
  }
  span {
    vertical-align: middle;
    margin-right: 50px;
  }
  .selected {
    background: #027db4;
    color: white;
  }
}

.select {
  font-size: 13px;
  margin: 40px 0 10px 0px;
  a {
    color: black !important;
    font: normal normal normal 27px/17px HappyZcool-2016;
    font-weight: 500;
    font-size: 17px;
    line-height: 45px;
    display: inline-block;
    border-radius: 40px;
    padding: 0 35px;
    box-shadow: 0px 3px 6px #00000029;
    min-width: 110px;
    height: 46px;
    margin-right: 10px;
    margin-bottom: 20px;
    &.selected {
      color: #fff !important;
      background-color: rgba(57, 165, 239, 1);
    }
  }

  &:hover {
    color: #333;
  }
}

.work-card {
  border: none;
  /deep/.ant-card-body {
    width: 250px;
    height: 280px;
    padding: 0;
    overflow: hidden;
    border-radius: 10px;
    box-shadow: 0px 3px 6px #00000039;
  }
  .ant-divider-horizontal {
    margin: 12px 0;
  }
  .work-cover {
    width: 100%;
    max-height: 150px;
    overflow: hidden;
    img {
      display: block;
      max-width: 100%;
      max-height: 100%;
      margin: auto;
    }
  }
  .work-author {
    padding: 10px 10px 0;
    span {
      line-height: 40px;
    }
  }
  .work-op {
    a {
      color: black;
    }
    a:hover {
      color: #1890ff;
    }
    padding: 0 10px;
  }
}
.user-card {
  border: none;
  cursor: pointer;
  /deep/.ant-card-body {
    width: 275px;
    height: 100px;
    padding: 10px;
    overflow: hidden;
    border-radius: 10px;
    box-shadow: 0px 3px 6px #00000039;
    .name {
      font-weight: bold;
      color: #555;
      text-decoration: none;
      font-size: 14px;
    }
  }
}

.ant-pagination {
  text-align: center;
  margin-top: 20px;
}
</style>